<script setup lang="ts">
  import { InsuranceSuccessWidget } from '@/widgets'
</script>

<template>
  <InsuranceSuccessWidget />
</template>
